const r = {
  postal_town: { key: "city", priority: 1 },
  locality: { key: "city", priority: 2 },
  administrative_area_level_2: { key: "city", priority: 3 },
  point_of_interest: { key: "streetName", priority: 1 },
  route: { key: "streetName", priority: 2 },
  street_number: { key: "streetNumber", priority: 1 },
  administrative_area_level_1: { key: "state", priority: 1 },
  country: { key: "country", priority: 1 },
  postal_code: { key: "zipCode", priority: 1 }
};
function c(i) {
  if (!i)
    return null;
  const t = i.address_components.reduce(
    (o, y) => {
      let s = -1;
      return y.types.forEach((e) => {
        var a, n;
        ((a = r[e]) == null ? void 0 : a.priority) > s && (o[(n = r[e]) == null ? void 0 : n.key] = y.long_name, s = r[e].priority);
      }), o;
    },
    {
      streetNumber: "",
      streetName: "",
      city: "",
      zipCode: "",
      state: "",
      country: ""
    }
  );
  return {
    street: [t.streetName, t.streetNumber].filter(Boolean).join(" "),
    city: t.city,
    country: t.country,
    state: t.state,
    zipCode: t.zipCode
  };
}
export {
  c as default
};
